import * as React from "react";
import '../css/pages/ConsultaCobranzas.css';
import '../css/search-filter/Filter.css';
import '../css/search-result/ResultTable.css';
import { EstadosConsultaCobranza } from "../enums-lists/EstadosConsultaCobranza";
import { RutValidator, FormatRutValidator, RequiredValidator, 
         ErrorValidations } from "../enums-lists/Validations";
import ResultsPerPage from "../enums-lists/ResultsPerPage";
import { getApiDateFormat } from "../functions/Format";
import { getCollectionList } from "../services/api-ssrr/CollectionManagerAPIClient";
import { CollectionModel } from "../types-interfaces/types";
import * as XLSX from 'xlsx';
import { MaterialReactTable, useMaterialReactTable } from "material-react-table";
import { useMemo } from "react";
import { columnsCollection } from "../enums-lists/TableColumns";
import { Alert, Button, Card, InputFecha, InputSelect, InputTexto, TextLink, Title } from "../components";
import { LuDownload } from "react-icons/lu";
import { TableSubtitleStyle } from "../components/styles/TitleStyle";
import { PrimaryButtonStyle } from "../components/styles/ButtonStyle";
import { useSelector } from "react-redux";
import { RootState } from "../redux/store";
import { UserState } from "../types-interfaces/interfaces";

interface ConsultaCobranzaProps {
  className?: string | undefined
  data?: Array<Array<string>>
  headersName?: Array<string>
};

interface ConsultaCobranzaState {
  rut?: string;
  cuenta?: string;
  idSolicitud?: string
  estadoConsultaCobranza?: number  
  fechaInicio?:string  
  fechaFin?: string
  tableData?: Array<CollectionModel>  
  calendarHiddenInicio?: boolean
  calendarHiddenFin?: boolean  
  consultaSinDatos?: boolean
  errorRut?: string
  errorCuenta?: string
  errorIdSolicitud?: string
  errorFechaInicio?: string | undefined
  errorFechaFin?: string | undefined
  alertVariant?: "warning" | "error" | "information" | "success" | "banner" | undefined
};

const initialConsultaCobranzaState: ConsultaCobranzaState = {
  rut: "",
  cuenta: "",
  idSolicitud: "",
  estadoConsultaCobranza: -1,  
  fechaInicio: new Date().toLocaleDateString().replaceAll("-","/"),
  fechaFin: '',
  tableData:[],  
  calendarHiddenInicio: true,
  calendarHiddenFin: true,  
  errorFechaInicio: "",
  errorFechaFin:"",
  alertVariant: undefined
}

const fechaCiclo = new Date();  //TODO: arreglar fecha ciclo
const fechaMin = new Date();
fechaMin.setMonth(fechaMin.getMonth()-6);

const dateValidator = (fechainicio?: string) => (fechafin?: string) =>{
  let val = false;

  if (fechafin && fechafin !== initialConsultaCobranzaState.fechaFin && fechainicio){
    val = Date.parse(fechafin.split("/").reverse().join()) < Date.parse(fechainicio.split("/").reverse().join())
  }        
  return val? ErrorValidations.EndDateGT : undefined;
}

function ConsultaCobranzas(props: ConsultaCobranzaProps){
  const [state, setState] = React.useState(initialConsultaCobranzaState);
  const userState = useSelector<RootState, UserState>((state) => state.userState);  
  const [pagination, setPagination] = React.useState({
    pageIndex: 0,
    pageSize: 10,
  });
  const [pageCount, setPageCount] = React.useState(0);
  const [rowCount, setRowCount] = React.useState(0);
  const [isLoadingTable, setIsLoadingTable] = React.useState(false);

  React.useEffect(() => {
    if ((pageCount !== 0 && rowCount !== 0 && pagination.pageIndex !== 0) || (pagination.pageIndex === 0 && pageCount !== 0)) {
      llamadaAPI(pagination.pageIndex+1);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pagination]);

  function rutChangeHandler(evt: React.ChangeEvent<HTMLInputElement>) {
    let newRut = evt.currentTarget.value.toUpperCase();
    let oldRut = state.rut ?? newRut.substring(0,newRut.length-1);
    const regexp = new RegExp("^[0-9K-]+$");
    if (
      (newRut && !regexp.test(newRut)) ||
      (newRut.startsWith("0") || newRut.startsWith("K")) ||
      (newRut.includes("-") && newRut.split("-").length > 1 && newRut.split("-")[1].length > 1) ||
      (newRut.includes("-") && newRut.lastIndexOf("-") !== newRut.indexOf("-")) ||
      (newRut.includes("K") && newRut.lastIndexOf("K") !== newRut.indexOf("K"))
    ){
      evt.currentTarget.value = oldRut;
    } else {
      setState({ ...state, rut: newRut });
    }    
  }

  function cuentaChangeHandler(evt: React.ChangeEvent<HTMLInputElement>){
    setState({ ...state, cuenta: evt.currentTarget.value });
  }
    

  function idSolicitudChangeHandler(evt: React.ChangeEvent<HTMLInputElement>){
    setState({ ...state, idSolicitud: evt.currentTarget.value });
  }
    

  function estadoChangeHandler(evt: React.ChangeEvent<HTMLSelectElement>){
    setState({ ...state, estadoConsultaCobranza: parseInt(evt.currentTarget.value)});
  }

  function limpiarFiltroHandler(evt: React.MouseEvent<HTMLInputElement>){
    setState({
      ...state,
      rut: initialConsultaCobranzaState.rut,
      cuenta: initialConsultaCobranzaState.cuenta,
      idSolicitud: initialConsultaCobranzaState.idSolicitud,
      estadoConsultaCobranza: initialConsultaCobranzaState.estadoConsultaCobranza,      
      fechaInicio: initialConsultaCobranzaState.fechaInicio,      
      fechaFin: initialConsultaCobranzaState.fechaFin      
    });
  }

  async function handleClickGenerarConsulta(event: React.MouseEvent<HTMLButtonElement, MouseEvent>){
    let error = false;
    let newState = state;
    
    //validaciones
    if (newState.fechaInicio === ''){
      error = true;
      newState.errorFechaInicio = ErrorValidations.Required;
    }

    if (newState.fechaFin === ''){      
      setState({ ...state, fechaFin: fechaCiclo.toLocaleDateString().replaceAll("-","/")});
    }

    if (newState.fechaInicio &&
        newState.fechaFin &&
        Date.parse(newState.fechaFin.split("/").reverse().join()) < Date.parse(newState.fechaInicio.split("/").reverse().join())
    ){
      newState.errorFechaFin = ErrorValidations.EndDateGT;
    }
    
    if (error || newState.errorFechaInicio !== "" || newState.errorFechaFin !== ""){
      
      setState(newState);
      return;
    }

    setPageCount(0);
    setRowCount(0);

    setPagination({
      pageIndex: 0,
      pageSize: pagination.pageSize
    });
    
    llamadaAPI(1);
  }

  function getFilters():string{    
    let filter = state.rut ? `&customerId=${state.rut}`: "";
    filter += state.cuenta ? `&accountId=${state.cuenta}`: "";
    filter += state.idSolicitud ? `&requestId=${state.idSolicitud}`: "";
    filter += (state.estadoConsultaCobranza ?? 0) > 0 ? `&status=${state.estadoConsultaCobranza}`: "";
    filter += state.fechaInicio ? `&dateFrom=${getApiDateFormat(state.fechaInicio)}`: "";
    filter += state.fechaFin ? `&dateTo=${getApiDateFormat(state.fechaFin)}`: "";
    return filter;
  }

  async function llamadaAPI(page: number){
    let filters = getFilters();

    let params = `page=${page}&size=${pagination.pageSize}` + filters;
    setIsLoadingTable(true);
    let result = await getCollectionList(params,userState.currentSession?.accessToken!,userState.currentSession?.user?.email!);
    setIsLoadingTable(false);

    if (!result || typeof(result) === "string" || !result.result || result.result.length === 0){
      setState({
        ...state,
        alertVariant: "error",
        consultaSinDatos: true,
        tableData: []
      })
      return;
    }

    let finalResult:CollectionModel[] = [];
    finalResult.push(...result.result);

    let data = result.result;

    setRowCount(result.paging.total);
    setPageCount(result.paging.pages);
    
    setState({
      ...state,
      alertVariant: undefined,
      consultaSinDatos: false,
      tableData: data,
    });
  }

  function handlerChangeDate(e:React.ChangeEvent<HTMLInputElement>, date: string): void {
    let oldDate = (date === "fecha-fin") ? state.fechaFin ?? "" : state.fechaInicio ?? "";
    let newDate = e.currentTarget.value;
    const regexp = RegExp("^[0-9/]+$");

    if (
      (newDate && !regexp.test(newDate)) ||      
      (newDate.split("/").length === 1 && parseInt(newDate.split("/")[0]) > 31) ||
      (newDate.split("/").length === 2 && parseInt(newDate.split("/")[1]) > 12) ||
      (newDate.split("/").length === 3 && newDate.split("/")[2].length > 4) ||
      (newDate.match(/\//g)?.length === 1 && newDate.indexOf("/",0) !== 2) ||
      (newDate.match(/\//g)?.length === 2 && newDate.indexOf("/",3) !== 5) ||
      (newDate.match(/\//g)?.length ?? 0) > 2 ||
      newDate.length > 10    
      ){
      e.currentTarget.value = oldDate;
    } else {
      let error = (newDate.length>0 && isInvalidDate(newDate)) ? ErrorValidations.InvalidDate : (newDate.length > 0 && newDate.length < 10)? ErrorValidations.Required: "";
      if (date === "fecha-inicio"){
        setState({
          ...state,
          fechaInicio: newDate,
          errorFechaInicio: error,
          calendarHiddenInicio: true
        })
      } else {
        setState({
          ...state,
          fechaFin:newDate,
          errorFechaFin: error,
          calendarHiddenFin: true
        })
      }
    }
  }

  function isInvalidDate(date:string): boolean{    
    const [day, month, year] = date.split('/');
    const dateObj = new Date(+year, +month - 1, +day);    
    return !(dateObj.toLocaleString('es-CL').substring(0,10).replaceAll("-","/") === date);
  }

  async function descargarDetalleXLSX(event: React.MouseEvent<HTMLButtonElement, MouseEvent>) {
    let filters = getFilters();
    let params = `page=${1}&size=${1}` + filters;
    let result = await getCollectionList(params,userState.currentSession?.accessToken!,userState.currentSession?.user?.email!);

    if (!result || typeof(result) === "string" || !result.result || result.result.length === 0){
      setState({
        ...state,
        alertVariant: "error",
        consultaSinDatos: true,
        tableData: []
      })
      return;
    }

    let finalResult:CollectionModel[] = [];

    for (let page = 1 ; page < ((result.paging.total / 500) + 1); page ++){
      params = `page=${page}&size=500` + getFilters();
      result = await getCollectionList(params,userState.currentSession?.accessToken!,userState.currentSession?.user?.email!);
  
      if (!result || typeof(result) === "string" || !result.result || result.result.length === 0){
        setState({
          ...state,
          alertVariant: "error",
          consultaSinDatos: true,
          tableData: []
        })
        return;
      }

      finalResult.push(...result.result);
    }

    const titulo = [["Reporte de Cobranzas"]];
  
    const workBook=XLSX.utils.book_new()
    const workSheet=XLSX.utils.json_to_sheet(finalResult.map((p) => {
      return ({
        'RUT cliente': p.customerId,
        'RUT pagador':p.payerId,
        'Monto': p.amount,
        'Moneda': p.currencyType,
        'Fecha devengo': p.accrualDate,
        'Money type': p.moneyType,
        'N° cuenta': p.accountId,
        'Producto': p.productType,
        'Fecha de cobranza': p.createAt,
        'Estado': p.status,
        'ID Solicitud': p.requestId,
        'ID Cobranza': p.id
      })
    }),{origin: 'A2', cellStyles:true});  

    //Tittle
    XLSX.utils.sheet_add_aoa(workSheet,titulo, { origin: 'A1' });
    
    XLSX.utils.book_append_sheet(workBook,workSheet,"Consulta Cobranzas")

    //Binary string
    XLSX.write(workBook,{bookType:"xlsx",type:"binary"})
    //Download
    XLSX.writeFile(workBook,"Consulta Cobranzas.xlsx")    
  }

  async function descargarDetalleCSV(event: React.MouseEvent<HTMLButtonElement, MouseEvent>) {
    let filters = getFilters();
    let params = `page=${1}&size=${1}` + filters;
    let result = await getCollectionList(params,userState.currentSession?.accessToken!,userState.currentSession?.user?.email!);

    if (!result || typeof(result) === "string" || !result.result || result.result.length === 0){
      setState({
        ...state,
        alertVariant: "error",
        consultaSinDatos: true,
        tableData: []
      })
      return;
    }

    let finalResult:CollectionModel[] = [];

    for (let page = 1 ; page < ((result.paging.total / 500) + 1); page ++){
      params = `page=${page}&size=500` + getFilters();
      result = await getCollectionList(params,userState.currentSession?.accessToken!,userState.currentSession?.user?.email!);
  
      if (!result || typeof(result) === "string" || !result.result || result.result.length === 0){
        setState({
          ...state,
          alertVariant: "error",
          consultaSinDatos: true,
          tableData: []
        })
        return;
      }

      finalResult.push(...result.result);
    }

    const titulo = [["Reporte de Cobranzas"]];
    const workSheet=XLSX.utils.json_to_sheet(finalResult.map((p) => {
      return ({
        'RUT cliente': p.customerId,
        'RUT pagador':p.payerId,
        'Monto': p.amount,
        'Moneda': p.currencyType,
        'Fecha devengo': p.accrualDate,
        'Money Type': p.moneyType,
        'N° cuenta': p.accountId,
        'Producto': p.productType,
        'Fecha de cobranza': p.createAt,
        'Estado': p.status,
        'ID Solicitud': p.requestId,
        'ID Cobranza': p.id
      })
    }),{origin: 'A2', cellStyles:true}); 
    const workBook=XLSX.utils.book_new()

    //Tittle
    XLSX.utils.sheet_add_aoa(workSheet,titulo, { origin: 'A1' });
    XLSX.utils.book_append_sheet(workBook,workSheet,"Consulta Cobranzas")

    //Binary string
    XLSX.write(workBook,{bookType:"csv",type:"binary"})
    //Download
    XLSX.writeFile(workBook,"Consulta Cobranzas.csv" )    
  }

  const collectionTable = useMaterialReactTable({
    columns: useMemo(() => columnsCollection,[]),
    data: state.tableData ?? [],
    onPaginationChange: setPagination,
    state: { pagination: pagination, isLoading: isLoadingTable },
    rowCount: rowCount,
    pageCount: pageCount,
    localization: {
      rowsPerPage: "Registros por página",
      showHideSearch: "mostrar / ocultar búsqueda",
      search:"Búsqueda",
      sortByColumnAsc:"Ordernar por {column} ascendente",
      sortByColumnDesc:"Ordernar por {column} descendente",
      sortedByColumnAsc: 'Ordernado por {column} ascendente',
      sortedByColumnDesc: 'Ordernado por {column} descendente',
    },
    muiTablePaperProps:{
      style:{
        boxShadow:"none"
      }
    },
    muiBottomToolbarProps:{
      style:{
        marginBottom:"25px",
        
      }
    },
    muiPaginationProps: {
      rowsPerPageOptions: ResultsPerPage,
      showRowsPerPage: true,
      shape:"rounded",
      variant:"text",
      style:{
        color: "#333",
        fontFeatureSettings: "'clig' off, 'liga' off",
        fontFamily: 'FS Elliot Pro Regular',
        fontSize: "16px",
        fontStyle: "normal",
        fontWeight: "400",
        lineHeight: "21px",
        padding: "13px",
      },
      property:"background-color: black",
      SelectProps:{
        style:{
          gap: "8px",
          padding: "13px",
          color: "#333",
          fontFeatureSettings: "'clig' off, 'liga' off",
          fontFamily: 'FS Elliot Pro Regular',
          fontSize: "16px",
          fontStyle: "normal",
          fontWeight: "400",
          lineHeight: "21px",
        }
      },      
    },
    paginationDisplayMode: 'pages',    
    enableColumnActions: false,
    enableDensityToggle:false,
    enableFullScreenToggle: false,
    enableHiding: false,
    enableFilters: true,
    enableColumnFilters: false,
    enablePagination: true,
    manualPagination: true
  })
  
  return(
    <div className={props.className}>
      <Title
        className={props.className + '-title'}
        text="Consulta cobranza"
      />
      <Card className="filter">
        <Card className="filter-row">
          <InputTexto
            className="filter-input"
            label="Filtrar por RUT del cliente"              
            value={state.rut}
            onChange={rutChangeHandler}              
            validators={[FormatRutValidator, RutValidator]}
            error={state.errorRut}
            alt="rut"
            
          />            
          <InputTexto
            className="filter-input"
            label="Filtrar por número de cuenta"              
            value={state.cuenta}
            onChange={cuentaChangeHandler}
            error={state.errorCuenta}
            alt="cuenta"
          />
          <InputTexto
            className="filter-input"
            label="Filtrar por ID solicitud"
            value={state.idSolicitud}
            onChange={idSolicitudChangeHandler}
            error={state.errorIdSolicitud}
            alt="id-solicitud"
          />
          <InputSelect
            className="filter-select"              
            label="Filtrar por estado de cobranza"              
            value={state.estadoConsultaCobranza}              
            onChange={estadoChangeHandler}
            values={EstadosConsultaCobranza}
            data-testid="estado-cobranza"
          />
        </Card>
        <Card className="filter-row">
          <InputFecha
            className="filter-fecha"
            label="Fecha de inicio"
            formatlabel="Usar el formato: DD/MM/AAAA"
            value={state.fechaInicio}
            validators={[RequiredValidator]}
            calendarhidden={state.calendarHiddenInicio}
            calendarmaxdate={fechaCiclo}
            calendarmindate={fechaMin}
            onClickDay={(e) => {setState({
              ...state,
              fechaInicio: e.toLocaleDateString().replaceAll("-","/"),
              calendarHiddenInicio: true,
              errorFechaInicio: ""})}}           
            onClick={() => { setState({
              ...state,
              calendarHiddenInicio: !state.calendarHiddenInicio,
              calendarHiddenFin: true})
            }}
            onMouseOver={() => setState({ ...state, calendarHiddenInicio: true})}
            alt="fecha-inicio"
            error={state.errorFechaInicio}
            onChange={(e) => handlerChangeDate(e,"fecha-inicio")}
          />
          <InputFecha
            className="filter-fecha"
            label="Fecha de termino"
            formatlabel="Usar el formato: DD/MM/AAAA"
            value={state.fechaFin}
            calendarhidden={state.calendarHiddenFin}
            calendarmaxdate={fechaCiclo}
            calendarmindate={fechaMin}
            onClickDay={(e) => {setState({
              ...state,
              fechaFin: e.toLocaleDateString().replaceAll("-","/"),
              calendarHiddenFin: true})}}              
            onClick={() => { setState({
              ...state,
              calendarHiddenFin: !state.calendarHiddenFin,
              calendarHiddenInicio: true})
            }}
            onMouseOver={() => setState({ ...state, calendarHiddenFin: true})}
            validators={[dateValidator(state.fechaInicio)]}
            alt="fecha-fin"
            error={state.errorFechaFin}
            onChange={(e) => handlerChangeDate(e,"fecha-fin")}
          />
          <div
            style={{
              display:"flex",
              flexDirection:"row",
              alignContent:"flex-end",
              alignSelf:"flex-end",
              justifyContent:"flex-end",
              width:"50%",
              gap:"20px"
            }}
          >
            <Button
              style={{
                ...PrimaryButtonStyle,                
                width:"15em",
                marginBottom:"0.1em"
              }}
              text="Generar Consulta"
              onClick={handleClickGenerarConsulta}
            />
            <TextLink
              className="filter-limpiar"              
              text="Limpiar filtros X"
              onClick={limpiarFiltroHandler}
            />
          </div>
        </Card>
      </Card>
      {state.consultaSinDatos &&
        <Alert          
          text="No se han encontrado cobranzas con las especificaciones entregadas, verifique los datos ingresados"
          type={state.alertVariant}
          onClose={() => {setState({ ...state, alertVariant:undefined, consultaSinDatos: false})}}
        />
      }
      <div className="result">
        <div className="result-title">          
          <Title
            text="Detalle de la cobranza"
            className="result-title-text"
            hidden={state.tableData === undefined || state.tableData.length < 1}
          />
          <Button
            className="result-title-download-button"
            text="Descargar detalle XLSX"              
            hidden={state.tableData === undefined || state.tableData.length < 1}
            children={<LuDownload/>}
            onClick={descargarDetalleXLSX}
          />
          <Button
            className="result-title-download-button"
            text="Descargar detalle CSV"              
            hidden={state.tableData === undefined || state.tableData.length < 1}
            children={<LuDownload/>}
            onClick={descargarDetalleCSV}
          />  
        </div>
        {((state.tableData && state.tableData.length > 0) || isLoadingTable) &&
        <>
          <Title
            text={`Resultado de la busqueda`}
            style={TableSubtitleStyle}                        
          />
          <MaterialReactTable table={collectionTable}/>
        </>
        }
        
      </div>
    </div>
  )
}

export default ConsultaCobranzas;